<micro-select-combo #sel
              placeholder="OAuth2 Grant Type"
              [mode]="mode"
              [(id)]="grantType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched">
</micro-select-combo>
